module.exports = __webpack_public_path__ + "static/Marilith-4e03878443a1174b2364a74e24c23243.jpg";